import { ImageLoader } from 'next/image'

// Docs: https://techdocs.akamai.com/ivm/reference/test-images-on-demand
export const akamaiImageLoader: ImageLoader = ({ src, width }) => {
  const url = new URL(src)

  url.searchParams.set('imwidth', width.toString())

  return url.toString()
}
